import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-drag-indicator",
  templateUrl: "./med-icon-drag-indicator.component.html",
})
export class MedIconDragIndicatorComponent extends SvgMixinComponent {}
